export default __webpack_public_path__ + "img/4eabaf8617c5c87e663a3c8999c2da36.png";